// enableInputPhone 內用手機必填
// enableTakeoutPhone 一般外帶顯示
// showInputPhone 內用手機顯示

import OrderServeType from '@/constants/OrderServeType';
import { isEmpty } from 'lodash';

// orderVo有 preOrderTime 時顯示
const showPhoneField = (webStoreVo, serveType, selectedTakeOutServeType) => {
  if (isEmpty(webStoreVo)) return false;
  const {
    isRoyaltyEnable,
    webUiConfig: { enableInputPhone, showInputPhone, enableTakeoutPhone },
  } = webStoreVo;

  if (isRoyaltyEnable) return true;

  if (
    OrderServeType.DINE_IN === serveType &&
    (enableInputPhone || showInputPhone)
  ) {
    return true;
  }

  if (
    OrderServeType.TAKE_OUT === serveType &&
    selectedTakeOutServeType === OrderServeType.TAKE_OUT
  ) {
    return true;
  }

  if (
    serveType === OrderServeType.TAKE_OUT &&
    selectedTakeOutServeType === OrderServeType.SCHEDULE_TAKE_OUT
  ) {
    return true;
  }

  if (serveType === OrderServeType.DELIVERY) {
    return true;
  }
  return false;
};

export default showPhoneField;
